var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.541571 1.67501C2.2249 3.83334 5.33324 7.83334 5.33324 7.83334V12.8333C5.33324 13.2917 5.70824 13.6667 6.16657 13.6667H7.83324C8.29157 13.6667 8.66657 13.2917 8.66657 12.8333V7.83334C8.66657 7.83334 11.7666 3.83334 13.4499 1.67501C13.8749 1.12501 13.4832 0.333344 12.7916 0.333344H1.1999C0.508238 0.333344 0.116571 1.12501 0.541571 1.67501Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.505db33c56ab60cafdce77ea9badfe2d.svg";
export { ForwardRef as ReactComponent };